// Modules
import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';

// UI
import { Spinner } from 'components/common/Spinner';

// Utils
import { RouteDefinition } from './types';
import { onlyPartnerAllowedMiddleware } from './middlewares/middlewares';
import { featureConfig } from 'config/features';

// Lazy loading wrapper with Suspense fallback
const LazyLoad = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={
    <div className="flex items-center justify-center w-full h-96">
      <Spinner size="lg" />
    </div>
  }>
    {children}
  </Suspense>
);

// Lazy load pages
const PartnerProjects = lazy(() => import('pages/Partners/PartnerProjects'));
const PartnerProjectDetail = lazy(() => import('pages/Partners/PartnerProjectDetail'));
const PartnerQuotes = lazy(() => import('pages/Partners/PartnerQuotes'));
const PartnerBilling = lazy(() => import('pages/Partners/PartnerBilling'));
const PartnerTeamMembers = lazy(() => import('pages/Partners/PartnerTeamMembers'));
const PartnerInternalContacts = lazy(() => import('pages/Partners/PartnerInternalContacts'));

export const partnerRoutes: RouteDefinition[] = [
  {
    enabled: featureConfig.partners,
    index: true,
    Component: <Navigate to="/partners/projects" replace />,
    middlewares: [onlyPartnerAllowedMiddleware],
  },
  {
    enabled: featureConfig.partners,
    path: 'projects',
    Component: (
      <LazyLoad>
        <PartnerProjects />
      </LazyLoad>
    ),
    middlewares: [onlyPartnerAllowedMiddleware],
  },
  {
    enabled: featureConfig.partners,
    path: 'projects/:id',
    Component: (
      <LazyLoad>
        <PartnerProjectDetail />
      </LazyLoad>
    ),
    middlewares: [onlyPartnerAllowedMiddleware],
  },
  {
    enabled: featureConfig.partners,
    path: 'quotes',
    Component: (
      <LazyLoad>
        <PartnerQuotes />
      </LazyLoad>
    ),
    middlewares: [onlyPartnerAllowedMiddleware],
  },
  {
    enabled: featureConfig.partners,
    path: 'billing',
    Component: (
      <LazyLoad>
        <PartnerBilling />
      </LazyLoad>
    ),
    middlewares: [onlyPartnerAllowedMiddleware],
  },
  {
    enabled: featureConfig.partners,
    path: 'team',
    Component: (
      <LazyLoad>
        <PartnerTeamMembers />
      </LazyLoad>
    ),
    middlewares: [onlyPartnerAllowedMiddleware],
  },
  {
    enabled: featureConfig.partners,
    path: 'internal-contacts',
    Component: (
      <LazyLoad>
        <PartnerInternalContacts />
      </LazyLoad>
    ),
    middlewares: [onlyPartnerAllowedMiddleware],
  },
];
